import './Footer2.css';
import logo from '../../Assets/Img/Logo.png';
import logob from '../../Assets/Img/Logoenblanco.png';
import { Link } from 'react-router-dom';

function Footer2() {
  return (
    <footer className="footer-container">

      {/* Línea decorativa superior */}
      <div className="footer-top-line"></div>

      {/* CONTENIDO PRINCIPAL */}
      <div className="footer-content">
        <div className="footer-main">

          {/* Columna 1: Branding */}
          <div className="footer-brand">
            <div className="brand-header">
              <img src={logo} className="logo-imag" alt="Tresa" />
              <span className="brand-name">TRESAEDU</span>
            </div>
            <p className="brand-description">
              Especialistas en desarrollo de software educativo y 
              soluciones digitales a medida. Adaptamos cada solución 
              a las necesidades específicas de tu institución.
            </p>
            <div className="brand-tag">
              <i className='bx bx-chip'></i>
              <span>Innovación educativa con tecnología</span>
            </div>
          </div>

          {/* Columna 2: Navegación de Plataforma */}
          <div className="footer-links">
            <div className="links-header">
              <i className='bx bx-grid-alt'></i>
              <h4>Plataforma Tresaedu</h4>
            </div>
            <ul className="links-list">
              <li>
                 <Link to="/gestionadministrativa" className="footer-link-item">
                  <i className='bx bx-buildings'></i>
                  <span>Gestión administrativa</span>
                </Link>
                
              </li>
              <li>
                <Link to="/Pedagogia" className="footer-link-item">
                  <i className='bx bx-book-open'></i>
                  <span>Pedagogía</span>
                </Link>
              </li>
              <li>
                <Link to="/Comunicacion" className="footer-link-item">
                  <i className='bx bx-message-rounded-dots'></i>
                  <span>Comunicación</span>
                </Link>
              </li>
              <li>
                <Link to="/" className="footer-link-item">
                  <i className='bx bx-info-circle'></i>
                  <span>Conocer Tresatec</span>
                </Link>
              </li>
              <li>
                <a 
                  href="https://wa.me/message/ORWIOZ4UP74NM" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-link-item highlight"
                >
                  <i className='bx bx-rocket'></i>
                  <span>Solicitar demo</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 3: Redes y Contacto */}
          <div className="footer-social">
            <div className="social-header">
              <i className='bx bx-share-alt'></i>
              <h4>Conectemos</h4>
            </div>
            <p className="social-description">
              Seguinos en nuestras redes o ponete en contacto con nosotros.
            </p>
            
            <div className="social-icons-grid">
              <a href="https://www.instagram.com/tresatec/" target="_blank" rel="noopener noreferrer" className="social-icon-item">
                <i className='bx bxl-instagram'></i>
                <span>Instagram</span>
              </a>
              <a href="https://wa.me/message/ORWIOZ4UP74NM1" target="_blank" rel="noopener noreferrer" className="social-icon-item">
                <i className='bx bxl-whatsapp'></i>
                <span>WhatsApp</span>
              </a>
              <a href="mailto:tresatec1@gmail.com" className="social-icon-item">
                <i className='bx bxl-gmail'></i>
                <span>Email</span>
              </a>
              <a href="https://www.linkedin.com/company/tresatec" target="_blank" rel="noopener noreferrer" className="social-icon-item">
                <i className='bx bxl-linkedin'></i>
                <span>LinkedIn</span>
              </a>
            </div>

            <div className="platform-access">
              <Link to="/Demo/" className="platform-btn">
                <img src={logob} className="logo-blan" alt="Acceso plataforma" />
                <span>Acceder a la plataforma</span>
              </Link>
            </div>
          </div>

        </div>
      </div>

      {/* Línea divisoria */}
      <div className="footer-divider"></div>

      {/* CRÉDITOS – BIEN ABAJO */}
      <div className="footer-bottom">
        <div className="footer-credits">
          <div className="credits-content">
            <span className="credits-text">
              <i className='bx bx-copyright'></i>
              2023 TRESAEDU by Tresatec
            </span>
            <span className="credits-tagline">
              Transformando la educación con tecnología
            </span>
          </div>
          <div className="credits-logo">
            <img src={logo} alt="Tresatec" />
          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer2;